// extracted by mini-css-extract-plugin
module.exports = {"block":"BlogList_block__wlBrt","image":"BlogList_image__CLCCB","description":"BlogList_description__pAQV3","link":"BlogList_link__0gt4x","root":"BlogList_root__W6xCi"};